/*
    Hide silver variant for product: Elevate Style: Clear Lucite Cane with Customizable Collar
    implemented: layout\theme.liquid, snippets\product-information-blocks.liquid, assets\product-info.js
*/
document.addEventListener("DOMContentLoaded", function () {

    function hideSilverVariant(sku = ''){
        console.log("hide silver variant", sku)

        const zepto_container = document.querySelector('.zepto-facade-container')

        if(!zepto_container){
            return console.log('Cant find zepto_container element for hidding silver variant ')
        }

        if(sku === '80308*silver'){
            setTimeout(() => {
                 const zepto_container = document.querySelector('.zepto-facade-container')
                  zepto_container.classList.add('hidden')
            }, 500);
           
        }

        zepto_container.classList.remove('hidden')
        

    }

    window.hideSilverVariant = hideSilverVariant;

})